<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">File-{{ file }}</h5>
    </div>
    <card-list-info header="File Detail" :items="infoList">
      <template slot="format" slot-scope={data}>Format :
        <span v-if="data.value === 'XLSX' || data.value === null"><i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel</span>
        <span v-else-if="data.value === 'PDF'"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> PDF</span>
        <span v-else-if="data.value === 'CSV'"><i class="fa fa-file-code-o" aria-hidden="true"></i> CSV</span>
      </template>
    </card-list-info>
  </b-card>
</template>
<script>
import CardListInfo from '@/components/CardListInfo';
import { isEmpty, get } from 'lodash';

export default {
  name: 'file_detail',
  components: {
    CardListInfo,
  },
  data() {
    return {
      file: null,
      infoList: [],
    };
  },
  created() {
    const { jobId } = this.$route.params;
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'report/files', name: 'Report Files' },
      { to: jobId, name: 'Details' },
    ]);
    this.$store.dispatch('report_files/LOAD_DATA');
  },
  computed: {
    files() {
      return this.$store.getters['report_files/files'];
    },
  },
  watch: {
    files(data) {
      const { jobId } = this.$route.params;
      const currentFile = data.find(f => f.job_id === jobId);

      if (!isEmpty(currentFile)) {
        const startDate = get(currentFile, 'options.date_time_range.start');
        const endDate = get(currentFile, 'options.date_time_range.end');
        const fileSize = `${currentFile.file_size} bytes`;
        const info = [
          { key: 'report_name', label: 'Report Name', value: currentFile.report_name },
          { key: 'file_name', label: 'File Name', value: currentFile.file_name },
          { key: 'file_size', label: 'File Size', value: fileSize },
          { key: 'format', label: 'File Format', value: currentFile.format },
          { key: 'start_date', label: 'Start Date', value: startDate },
          { key: 'end_date', label: 'End Date', value: endDate },
        ];

        this.infoList = [...info];
        this.file = currentFile.file_name;
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/pages/report/files/Detail.vue